import {AppFunction} from "../misc/types";
import View from "../framework/view";
import ReviewView from "../views/review";

export class ReviewFunction extends AppFunction {

    readonly v : View;

    private token : string;

    constructor(token: string) {
        super();
        this.token = token;
        this.v = new ReviewView(token);
    }

    view() {
        return this.v;
    }

    url() {
        return `/review/${encodeURIComponent(this.token)}`;
    }

}
